// ============================================================================
// Click-to-copy wrapper used across the OMS order detail. Clicking a lead id or
// PO number copies its raw value to the clipboard and toasts. Stops propagation
// so copying inside a clickable container (e.g. the allocation card header, which
// toggles expand on click) doesn't also fire that container's handler.
// ============================================================================
import { message } from "antd";
import React from "react";

const CopyText: React.FC<{
  value?: string | null;
  children?: React.ReactNode; // display content; falls back to the raw value
  label?: string; // named in the toast + tooltip, e.g. "Lead ID" / "PO number"
  style?: React.CSSProperties;
}> = ({ value, children, label, style }) => {
  const text = (value ?? "").toString().trim();

  // Nothing to copy — render the display content plainly (no pointer, no handler).
  if (!text) return <>{children ?? "—"}</>;

  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      message.success(`Copied ${label ? `${label} ` : ""}${text}`);
    } catch {
      message.error("Couldn't copy to clipboard");
    }
  };

  return (
    <span
      role="button"
      onClick={copy}
      title={`Click to copy${label ? ` ${label}` : ""}`}
      style={{ cursor: "pointer", ...style }}
    >
      {children ?? text}
    </span>
  );
};

export default CopyText;
